var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "contact" }, [
    _c(
      "div",
      { staticClass: "column", attrs: { id: "contact-office-nice" } },
      [
        _c("div", { staticClass: "title" }, [_vm._v("Nice")]),
        _vm._v(" "),
        _c("line-footer"),
        _vm._v(" "),
        _vm._m(0),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column", attrs: { id: "contact-office-cairo" } },
      [
        _c("div", { staticClass: "title" }, [_vm._v("Cairo")]),
        _vm._v(" "),
        _c("line-footer"),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column", attrs: { id: "contact-office-dubai" } },
      [
        _c("div", { staticClass: "title" }, [_vm._v("Dubai")]),
        _vm._v(" "),
        _c("line-footer"),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _vm._m(4),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "details" }, [
      _c("p", [
        _vm._v("\n                Indigen Solutions"),
        _c("br"),
        _vm._v("29 Rue Pastorelli"),
        _c("br"),
        _vm._v("06000 Nice,\n                France\n                "),
        _c(
          "a",
          {
            staticClass: "link",
            attrs: {
              target: "_blank",
              href: "https://maps.app.goo.gl/6nzWt4noVt6vqgWz8",
            },
          },
          [_vm._v("\n                    See on map\n                ")]
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                Happy to hear from you at:\n                "
        ),
        _c(
          "a",
          {
            staticClass: "link",
            attrs: { href: "mailto:contact@indigen.com" },
          },
          [
            _vm._v(
              "\n                    contact@indigen.com\n                "
            ),
          ]
        ),
        _vm._v(" "),
        _c("a", { staticClass: "link", attrs: { href: "tel:+33493550601" } }, [
          _vm._v("\n                    +33 4 93 55 06 01\n                "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n            Indigen Cairo"),
      _c("br"),
      _vm._v("4, zone 1258, Abd El-Hameed Badawi ST,\n            "),
      _c("br"),
      _vm._v("Sheraton, Cairo, Egypt\n            "),
      _c(
        "a",
        {
          staticClass: "link",
          attrs: {
            target: "_blank",
            href: "https://maps.app.goo.gl/xvatRww77a7yCux89",
          },
        },
        [_vm._v("\n                See on map\n            ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n            Happy to hear from you at:\n            "),
      _c(
        "a",
        { staticClass: "link", attrs: { href: "mailto:contact@indigen.com" } },
        [_vm._v("\n                ahlan@indigen.com\n            ")]
      ),
      _vm._v(" "),
      _c("a", { staticClass: "link", attrs: { href: "tel:+201275883258" } }, [
        _vm._v(" +20 12 75 88 3258 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n            Indigen Middle-East L.L.C-FZ"),
      _c("br"),
      _vm._v("\n            The Meydan Hotel, Grandstand, 6th floor, "),
      _c("br"),
      _vm._v(
        "Meydan Road, Nad\n            Al Sheba, Dubai, U.A.E\n            "
      ),
      _c(
        "a",
        {
          staticClass: "link",
          attrs: {
            target: "_blank",
            href: "https://maps.app.goo.gl/p4n6peTyb5KMNheN8",
          },
        },
        [_vm._v("\n                See on map\n            ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n            Happy to hear from you at:\n            "),
      _c(
        "a",
        { staticClass: "link", attrs: { href: "mailto:contact@indigen.com" } },
        [_vm._v("\n                ahlan@indigen.com\n            ")]
      ),
      _vm._v(" "),
      _c("a", { staticClass: "link", attrs: { href: "tel:+971504557665" } }, [
        _vm._v(" +971 50 455 7665 "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }